<template>
  <section class="landing-live-section">
    <b-container>
      <h4 class="title">Today's live sessions</h4>
      <div class="live-tab">
        <b-container>
          <banner-slider :slides="3" :liveCourses="liveCourses" />
        </b-container>
      </div>
    </b-container>
  </section>
</template>

<script>
import BannerSlider from "../Templates/BannerSlider.vue";
export default {
  components: {
    BannerSlider
  },
  data() {
    return {
      imageArray: ["img/live1bg.png", "img/live2bg.png", "img/live3bg.png"]
    };
  },
  props: {
    liveCourses: Array
  }
};
</script>

<style></style>
